import { render } from "./Webmaster.vue?vue&type=template&id=b2de6124"
import script from "./Webmaster.vue?vue&type=script&lang=js"
export * from "./Webmaster.vue?vue&type=script&lang=js"

import "./Webmaster.vue?vue&type=style&index=0&id=b2de6124&lang=scss"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__